export function safeParseFloat(value: string | number | null | undefined, defaultValue?: number): number | undefined {
	// Value is undefined
	if (value === undefined || value === null) {
		return defaultValue;
	}

	let parsed: number | undefined;

	// Attempt to parse
	try {
		// Value is already a number
		if (typeof value === 'number') {
			parsed = value;
		} else {
			parsed = Number.parseFloat(value);
		}
	} catch {
		parsed = undefined;
	}

	// Set to undefined if the value isn't a number
	if (Number.isNaN(parsed)) {
		parsed = undefined;
	}

	// Return the parsed value or default value
	return parsed ?? defaultValue;
}
